import { useParams } from "react-router-dom";

import { parsePositiveIntParam } from "@src/shared/utils/params";

export function usePatientIdFromParams(): number | null {
  const params = useParams();
  return parsePositiveIntParam(params.patientId) ?? null;
}
